export default __webpack_public_path__ + "static/media/paack-mssii.008c20b2.svg";